var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.203,
    height: 87.321,
    viewBox: "0 0 26.203 87.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin",
    transform: "translate(-1711.535 -497.194)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 12.738,
    cy: 4.6,
    rx: 12.738,
    ry: 4.6,
    transform: "translate(1712.262 575.315)",
    opacity: 0.317
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 7.077,
    cy: 1.769,
    rx: 7.077,
    ry: 1.769,
    transform: "translate(1717.924 578.146)",
    opacity: 0.299
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(-203 -90.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M26.128,0V21.7a12.85,12.85,0,0,1-1.1,5.016,13.5,13.5,0,0,1-2.8,4.1,13.034,13.034,0,0,1-4.128,2.77,12.989,12.989,0,0,1-10.086,0,13.016,13.016,0,0,1-4.128-2.77,13.471,13.471,0,0,1-2.8-4.1A12.823,12.823,0,0,1,0,21.7V0Z",
    transform: "translate(1940.738 622) rotate(180)",
    fill: "#58c2d7",
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M393.7,349.51v21.7a12.851,12.851,0,0,1-1.1,5.016,13.5,13.5,0,0,1-2.8,4.1,13.034,13.034,0,0,1-4.128,2.77,12.989,12.989,0,0,1-10.086,0,13.016,13.016,0,0,1-4.128-2.77,13.471,13.471,0,0,1-2.8-4.1,12.823,12.823,0,0,1-1.1-5.016v-21.7Z",
    transform: "translate(1546.962 272.49)",
    fill: "#902d84",
    opacity: 0.996
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M6.5,0,13,13H0Z",
    transform: "translate(1732 573) rotate(180)",
    fill: "#902d84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M6.608-5.712H3.178V-9.646H1.134V0H3.178V-3.878h3.43V0H8.68V-9.646H6.608Zm4.1-.826V0h1.932V-6.538Zm.966-3.556A1.176,1.176,0,0,0,10.458-8.96a1.188,1.188,0,0,0,1.218,1.148,1.172,1.172,0,0,0,1.19-1.148A1.16,1.16,0,0,0,11.676-10.094Z",
    transform: "translate(1718 551)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.212a267d042b0a354226cef5cf975ded.svg";
export { ForwardRef as ReactComponent };